import React from 'react';
import './App.css';
import { Route } from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute'
import LandingPage from './components/LandingPage'
import LoginBusiness from './components/LoginBusiness'
import LoginVolunteer from './components/LoginVolunteer'
import RegisterBusiness from './components/RegisterBusiness'
import RegisterVolunteer from './components/RegisterVolunteer'
import VolunteerDashboard from './components/VolunteerDashboard'
import BusinessDashboard from './components/BusinessDashboard'
import FailedLogin from './components/FailedLogin'
import AddFoodItem from './components/AddFoodItem'
import GetAllFoodItems from './components/GetAllFoodItems';
import UpdateFoodItem from './components/UpdateFoodItem'

class App extends React.Component {

  // logout = (evt) => {
  //   evt.preventDefault()
  //   localStorage.removeItem('token')
  //   this.props.history.push('/login')
  // }

  render(){
    return (
      <div className="App">
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/loginBusiness" component={LoginBusiness} />
        <Route exact path="/loginVolunteer" component={LoginVolunteer} />
        <Route exact path="/registerBusiness" component={RegisterBusiness} />
        <Route exact path="/registerVolunteer" component={RegisterVolunteer} />
        <Route exact path="/failedlogin" component={FailedLogin} />
        <Route exact path="/AddFoodItem" component={AddFoodItem} />
        <Route exact path="/GetAllFoodItems" component={GetAllFoodItems} />
        <Route exact path="/UpdateFoodItem" component={UpdateFoodItem} />
        <PrivateRoute exact path="/businessdashboard" component={BusinessDashboard} />
        <PrivateRoute exact path="/volunteerdashboard" component={VolunteerDashboard} />
      </div>
    )
  }
}

export default App;
